import React from 'react';

const CategoryWrapper = ({children}) => {
    return <article>{children}</article>;
};

export default CategoryWrapper;
